import { useToggle } from '../../../global/utils/hooks/useToggle';
import styles from './GallerySection.module.scss';
import { Modal, ModalHeader, ModalBody, Row, Col, Badge } from 'reactstrap';
import { useState, useEffect } from 'react';


export default function GallerySection(props) {
    const [modal, setModal, toggleModal] = useToggle(false);

    const [image, setImage] = useState('');
    const [active, setActive] = useState();   
    const [status, setStatus] = useState(props.product.status);
    const [badgeColor, setBadgeColor] = useState(); 
    
    const imageHandleClick = (e) => {
        e.preventDefault();

        toggleModal();
        let imageSource = e.target.getAttribute('src');
        let imageId = e.target.getAttribute('id');
        setImage(imageSource);
        setActive(imageId);
        
    }

    const imageActiveHanldeClick = (e) => {
        e.preventDefault();

        let imageSource = e.target.getAttribute('src');
        let imageId = e.target.getAttribute('id');
        setImage(imageSource);
        setActive(imageId);

        return imageSource
    }

    useEffect(() => {
        if(status == 'PENDING'){
          setBadgeColor('warning');
        }
        if(status == 'REJECT') {
          setBadgeColor('danger');
        }
        if(status == 'SOLD') {
          setBadgeColor('light');
        }
        if(status == 'CLOSED') {
          setBadgeColor('dark');
        }
        if(status == 'EXPIRED') {
          setBadgeColor('danger');
        }
      },[status]);

  return (
    <div className={`${styles.productImages}`}>
        <div className={`${styles.featureImage} mb-3 position-relative`}>
            {
                status !== "APPROVE" &&
                    <Badge 
                        className={`position-absolute ${badgeColor == 'light' && "text-dark"} customBadge`} 
                        color={badgeColor}
                    >
                        {status}
                    </Badge>
            }
            {
            props.product &&
                <img 
                    src={`${!props.product.image ? '/images.png' : `${process.env.REACT_APP_API_URL}${props.product.image}`}`}
                    className="img-fluid"
                    onClick={imageHandleClick}
                />
            }
        </div>
        <div className={`d-flex ${styles.thumbImages}`}>
            {
                 props.product &&
                 props.product.galleries.map((img,index) => 
                    <div key={img.id}>
                    {index < 3 
                        ? (
                            <div 
                                className={`${styles.thumbImage} me-2 d-flex align-items-center`}>

                            <img 
                                src={`${process.env.REACT_APP_API_URL}${img.url}`} 
                                id={img.id} 
                                alt={img.title}
                                onClick={imageHandleClick}
                                /> 
                            </div>
                        ) 
                        : index == 3 && 
                        <div className={`position-relative d-flex align-items-center justify-content-center`}>
                            <div className={`${styles.thumbImage} d-flex align-items-center`}>
                                <img 
                                    src={`${process.env.REACT_APP_API_URL}${img.url}`} 
                                    key={img.id} 
                                    id={img.id} 
                                    alt={img.title}
                                    onClick={imageHandleClick}
                                    className={`${styles.overlay}`}
                                    /> 
                            </div>
                            <div 
                                className={`position-absolute ${styles.overlayIcon}`}
                                >
                                <i 
                                    className="bi bi-three-dots"
                                    src={`${process.env.REACT_APP_API_URL}${img.url}`} 
                                    onClick={imageHandleClick}
                                    ></i>
                            </div>
                        </div>
                        }
                    </div>
                 )
            }
        </div>
        <Modal isOpen={modal} toggle={toggleModal} size='lg'>
            <ModalHeader 
                toggle={toggleModal}
            >
                Product Images
            </ModalHeader>
            <ModalBody className={`${styles.modalBody}`}>
                <Row>
                    <Col sm={12} xl={7}>
                        <img src={image} className="img-fluid" />
                    </Col>
                    <Col sm={12} xl={5}>
                        <h6 className={`mb-2 ${styles.productTitle}`}>
                            {props.product.title}
                        </h6>
                        <div className={`d-flex ${styles.thumbImages} ${styles.modalImages}`}>
                            {
                            props.product &&
                                props.product.galleries.map((img) => 
                                    <div 
                                        key={img.id}
                                        className={`
                                            ${styles.thumbImage} 
                                            ${img.id == active ? styles.active : ''}
                                            me-2 mb-2 d-flex align-items-center `}>
                                        <img 
                                            src={`${process.env.REACT_APP_API_URL}${img.url}`}  
                                            id={img.id} 
                                            alt={img.title}
                                            onClick={imageActiveHanldeClick}
                                            className={`img-fluid`}
                                            /> 
                                    </div> 
                                )
                            }
                        </div>
                    </Col>
                </Row>
            </ModalBody>
      </Modal>
    </div>
  )
}
